import { Expose } from 'class-transformer'

export class GetUserTagsDTO {

    @Expose()
    tags!: string[]

}
